// metaMixin.js
import { sizeToMetaId } from "@/lib/ListingFilters.js"
import { mapState } from "vuex"

export const metaMixin = {
  methods: {
    setMeta() {
      if (this.meta == null) return

      document.title = this.meta.title
      this.setMetaContent("description", this.meta.description)
      this.setMetaContent("keywords", this.meta.keyword)
    },
    setMetaContent(name, content) {
      document.querySelector(`meta[name="${name}"]`)?.setAttribute("content", content)
    },
    firstFilter(filterType) {
      return this[filterType].length === 1 ? this[filterType][0] : null
    },
  },
  computed: {
    meta() {
      if (this.oneCollection) {
        return this.metas[this.firstFilter("collections")]["default"]
      } else if (this.oneArtStyle) {
        return this.metas[this.firstFilter("art_styles")]["default"]
      } else if (this.oneMedium) {
        return this.metas[this.firstFilter("mediums")]
      } else if (this.sizes.length === 1 && this.noCollectionsOrMediums) {
        return this.metas[sizeToMetaId(this.sizes[0])]
      }
      return null
    },
    oneCollection() {
      return this.firstFilter("collections") && !this.firstFilter("mediums")
    },
    oneArtStyle() {
      return !this.firstFilter("collections") && this.firstFilter("art_styles")
    },
    oneMedium() {
      return this.firstFilter("mediums") && !this.firstFilter("collections") && !this.firstFilter("art_styles")
    },
    noCollectionsOrMediums() {
      return this.mediums.length === 0 && this.collections.length === 0 && this.art_styles.length === 0
    },
    ...mapState("filter", {
      collections: (state) => state.filters.collections,
      mediums: (state) => state.filters.mediums,
      art_styles: (state) => state.filters.art_styles,
      sizes: (state) => state.filters.sizes,
      metas: ({ config }) => config.meta,
    }),
  },
  mounted() {
    this.$nextTick(() => this.setMeta())
  },
  updated() {
    this.setMeta()
  },
}
